import { enumToOptions as l } from "../utils/utils.js";
import { HookBuilder as f, EnumerationService as g } from "@propify-tenant-client/services";
import { useMemo as t } from "react";
const h = f.regularHook(["enumerations"], g.getEnums, {
  errorMessage: "There was an error while loading the enumeration"
}), w = (s, r) => {
  const { data: o, isFetching: a, refetch: i, error: u } = h([s]), e = t(
    () => r ? (o ?? []).filter(r) : o ?? [],
    [o, r]
  ), m = t(() => l(e), [e]), c = t(
    () => e.reduce((n, { value: d, displayName: p }) => (n[d] = p, n), {}),
    [e]
  );
  return {
    data: e,
    isFetching: a,
    refetch: i,
    error: u,
    options: m,
    displayNamesMap: c
  };
};
export {
  w as default
};
//# sourceMappingURL=useEnumeration.js.map
